(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("SPAUI"), require("OD_ICON"), require("_"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "SPAUI", "OD_ICON", "_", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ODC"] = factory(require("React"), require("SPAUI"), require("OD_ICON"), require("_"), require("ReactDOM"));
	else
		root["ODC"] = factory(root["React"], root["SPAUI"], root["OD_ICON"], root["_"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__70__, __WEBPACK_EXTERNAL_MODULE__89__) {
return 